module.exports = __webpack_public_path__ + "static/img/p2_1.4141ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product/p2_1.png
// module id = zcvi
// module chunks = 1